<span [matMenuTriggerFor]="menu" (menuClosed)="emitMenuClose()"></span>

<ng-container>
  <mat-menu #menu="matMenu">
    <div class="wrapper p-2" (click)="click($event)">
      <ng-container *ngIf="project.loaded; else loadingProject">
        <section class="detail">
          <div class="detail-row detail-row--between">
            <div class="link" (click)="navigateToProject(project?.data?.id)">
              <i class="icon icon-Project"></i>
              <span class="info">{{ project?.data?.name }}</span>
            </div>
            <span class="close-btn" (click)="closeMenu()"><i class="icon icon-close_ico"></i></span>
          </div>

          <div class="detail-row" *ngIf="project?.data?.client">
            <i class="icon icon-Clients"></i>
            <span class="info">{{ project.data.client.name }}</span>
          </div>

          <div class="detail-row">
            <i class="icon icon-Time"></i>
            <div class="row-flex row-flex--column mx-0 pr-1 border-right w-50">
              <span class="info">{{ 'Start' | translate }}</span>
              <span class="info">{{ project?.data?.start_date | formatDate: 'DD.MM.YYYY' }}</span>
            </div>

            <div class="row-flex row-flex--column mx-0 pl-1 w-50">
              <span class="info">{{ 'End' | translate }}</span>
              <span class="info">{{ project?.data?.end_date | formatDate: 'DD.MM.YYYY' }}</span>
            </div>
          </div>

          <div class="detail-row">
            <i class="icon icon-Address_ico btn-icon--geo"></i>
            <ng-container *ngIf="project?.data?.project_location; else noSet">
              <span class="info">{{ project.data.project_location.address }}</span>
            </ng-container>
          </div>

          <ng-container *ngIf="!isWorker">
            <div class="detail-row">
              <i class="icon icon-Employee"></i>
              <span class="info">{{ 'Assigned' | translate }}</span>
            </div>

            <div *ngIf="assignUserCollection.loaded; else loadingUsers" class="detail-row detail-row__middle ml">
              <ng-container *ngFor="let item of assignUserCollection.items; trackBy: identifyUser">
                <logo [small]="true" [url]="item.avatars?.small_thumb_path" [matTooltip]="item?.full_name"></logo>
              </ng-container>

              <span *ngIf="assignUserCollection?.meta?.totalCount > assignUserCollection.items?.length" class="ml-1">
                +{{ assignUserCollection.meta.totalCount - assignUserCollection.items.length }}
              </span>
            </div>
          </ng-container>
        </section>

        <div
          *ngIf="!isWorker && !hideActionBtns"
          class="row-flex row-flex--between row-flex--middle mx-0"
          [class.mt-2]="!isWorker">
          <button class="action-item" (click)="delete()">
            <span class="icon-wrap">
              <i class="icon icon-Delete_ico" [matTooltip]="'Delete' | translate"></i>
            </span>
          </button>

          <btn-action
            styleClasses="black"
            iconClass="icon-Edit"
            [withIcon]="true"
            [buttonLabel]="'Edit' | translate"
            (applyAction)="edit()">
          </btn-action>
        </div>
      </ng-container>
    </div>
  </mat-menu>
</ng-container>

<ng-template #loadingProject>
  <div class="loader-wrap">
    <loader [loading]="project?.loading$"></loader>
  </div>
</ng-template>

<ng-template #loadingUsers>
  <loader [loading]="assignUserCollection?.loading$" [small]="true"></loader>
</ng-template>

<ng-template #noSet>
  <span class="no-set__value">
    {{ 'No set' | translate }}
  </span>
</ng-template>
